/**
 * Quran Foundation SDK Client (Singleton)
 *
 * Uses @quranjs/api SDK which handles:
 * - OAuth2 token management (auto-request, caching, refresh)
 * - Retry with exponential backoff
 * - Required headers injection
 *
 * OAuth2 requests are proxied through our Worker API to bypass CORS
 * and optionally keep credentials secure on the server.
 */

import { QuranClient } from '@quranjs/api';

const clientId = import.meta.env.VITE_QURAN_CLIENT_ID;
const clientSecret = import.meta.env.VITE_QURAN_CLIENT_SECRET;
const apiUrl = import.meta.env.VITE_API_URL;

if (!clientId || !clientSecret) {
  console.error(
    'Missing Quran Foundation API credentials. ' +
    'Set VITE_QURAN_CLIENT_ID and VITE_QURAN_CLIENT_SECRET in your .env file. ' +
    'Request access: https://api-docs.quran.foundation/request-access'
  );
}

if (!apiUrl) {
  console.error(
    'Missing VITE_API_URL. ' +
    'Set VITE_API_URL in your .env file (e.g., http://localhost:8787 for dev)'
  );
}

// OAuth2 requests go through our Worker API (bypasses CORS, keeps credentials secure)
const authBaseUrl = apiUrl ? `${apiUrl}/api/qf-auth` : '';

// Content API calls Quran Foundation directly (no proxy needed)
const contentBaseUrl = 'https://apis.quran.foundation';

export const quranClient = new QuranClient({
  clientId: clientId ?? '',
  clientSecret: clientSecret ?? '',
  authBaseUrl,
  contentBaseUrl,
});

export default quranClient;
